var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2369_28553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8333 14V12.6667C11.8333 11.9594 11.5523 11.2811 11.0522 10.781C10.5521 10.281 9.87387 10 9.16663 10H3.83329C3.12605 10 2.44777 10.281 1.94767 10.781C1.44758 11.2811 1.16663 11.9594 1.16663 12.6667V14",
    stroke: "#A3A3A3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50004 7.33333C7.9728 7.33333 9.16671 6.13943 9.16671 4.66667C9.16671 3.19391 7.9728 2 6.50004 2C5.02728 2 3.83337 3.19391 3.83337 4.66667C3.83337 6.13943 5.02728 7.33333 6.50004 7.33333Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 14V12.6667C15.8329 12.0758 15.6363 11.5019 15.2743 11.0349C14.9123 10.5679 14.4055 10.2344 13.8334 10.0867",
    stroke: "#A3A3A3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1666 2.08667C11.7402 2.23354 12.2487 2.56714 12.6117 3.03488C12.9748 3.50262 13.1719 4.07789 13.1719 4.67C13.1719 5.26212 12.9748 5.83739 12.6117 6.30513C12.2487 6.77287 11.7402 7.10647 11.1666 7.25334",
    stroke: "#A3A3A3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2369_28553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.78a45d1438730f819feadf57e301e323.svg";
export { ForwardRef as ReactComponent };